var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiversx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4390_958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3195 12.204L24 6.46881L22.2045 3L12.4244 6.97583C12.1726 7.07834 11.8934 7.07834 11.6416 6.97583L1.86153 3L0.065918 6.46881L10.7465 12.204L0.065918 17.9391L1.86153 21.4079L11.6416 17.4321C11.8934 17.3296 12.1726 17.3296 12.4244 17.4321L22.2045 21.4079L24 17.9391L13.3195 12.204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4390_958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.5,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiversx);
export default __webpack_public_path__ + "static/media/multiversx.9e800484d73bc5019c6efa135862bb9c.svg";
export { ForwardRef as ReactComponent };